import React, { useContext, useState } from 'react';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    Chip,
    Button,
    Grid,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    ThemeProvider,
    createTheme,
    CssBaseline,
    TableContainer,
    TextField,
    CardHeader,
    MenuItem,
    Select
} from '@mui/material';
import {
    Close,
    Print,
    Receipt,
    ContentCopy,
    LocalShipping,
    Inventory,
    LocationOn,
    Edit,
    Scale,
    ShoppingBag,
    CircleNotificationsRounded,
    InventoryRounded
} from '@mui/icons-material';
import '../../assets/styles/OrderDetails.scss';
import { CommonContext, GaintOFDOrdersContext } from '../../context';
import moment from 'moment/moment';
import { booking_type_id, delivery_type_id, service, zones } from '../../utils/config';
import commonApi from '../../utils/api';
import { scrollToTop } from '../common/scrollToTop';

const theme = createTheme({
    palette: {
        primary: {
            main: '#004d40',
        },
    },
});

const OrderDetails = () => {
    // const [isOpen, setIsOpen] = useState(false);
    const { user, merchant, getOrderStatus } = useContext(CommonContext);
    const { details, isOpen, setIsOpen, setIsLoading } = useContext(GaintOFDOrdersContext);
    const [formData, setFormData] = useState({
        "new_merchant_id": '',
    });
    const [formRemaks, setFormRemaks] = useState({
        remarks: '',
    });
    const [formErrors, setFormErrors] = useState({});
    const [allRemarks, setAllRemarks] = useState([]);


    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormRemaks((prevData) => ({
            ...prevData,
            [name]: type === 'file' ? event.target.files[0] : value,
        }));
    };


    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    const onRemakrsListApi = (id) => {
        let postReq = { order_id: id };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setIsLoading(true);
        commonApi.post('orders/remarks-list', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    setAllRemarks(response?.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };

    const handleRemarksSubmit = (e) => {
        e.preventDefault();
        const errors = {};
        if (!formRemaks.remarks.trim()) {
            errors.remarks = 'Remarks is required';
        }
        setFormErrors(errors);
        formRemaks.order_id = details?.id
        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            commonApi.post('orders/add-remarks', formRemaks)
                .then((response) => {
                    setIsLoading(false);
                    // setOpenAlert(true);
                    scrollToTop('drawer-body-content');
                    if (response?.data?.s === 1) {
                        onRemakrsListApi(details?.id);
                        // setAlertMessage(response?.data?.msg);
                        // setSeverity('success');
                    } else {
                        // setAlertMessage(response?.data?.msg);
                        // setSeverity('error')
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    // setOpenAlert(true);
                    // setAlertMessage(error?.response?.data?.msg);
                    // setSeverity('error')
                    console.error('Error fetching data:', error);
                });
        }
    };
    const handleInputChange = (event, index, category) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'file' ? event.target.files[0] : value,
        }));
        if (name === 'merchant_id' || name === 'merchant_warehouse_id' || name === 'status') {
            setFormData((prevData) => ({
                ...prevData,
                value,
            }));
        }
    };
    const onMerchantUpdate = () => {
        formData.order_id = details?.id
        formData.admin_id = user?.id
        setIsLoading(true);
        commonApi.post('/orders/update-merchant-id ', formData)
            .then((response) => {
                setIsLoading(false);
                // setOpenAlert(true);
                if (response?.data?.s === 0) {
                    // setAlertMessage(response?.data?.msg);
                    // setSeverity('error')
                } else {
                    // setAlertMessage('Merchant Updated');
                    // setSeverity('success');
                    // viewDetail(details?.id);
                }
            })
            .catch((error) => {
                // setOpenAlert(true);
                setIsLoading(false);
                // setAlertMessage(error?.response?.data?.msg);
                // setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box className="order-details-container">
                <Drawer
                    anchor="right"
                    open={isOpen}
                    onClose={handleToggleDrawer}
                    className="order-drawer"
                    PaperProps={{
                        className: "drawer-paper"
                    }}
                >
                    <Box className="drawer-content">
                        {/* Header */}
                        <Box className="drawer-header">
                            <Box className="header-left">
                                <Inventory className="header-icon" />
                                <Typography variant="h5" className="header-title">
                                    Orders Details B2C
                                </Typography>
                                <Box className="basic-info">
                                    <Box className="info-item">
                                        <Typography variant="body2" className="info-label">Courier:</Typography>
                                        <Typography variant="body2" className="info-value">{details?.courier?.brand_name}</Typography>
                                    </Box>
                                    <Box className="info-item">
                                        <Typography variant="body2" className="info-label">AWB:</Typography>
                                        <Typography variant="body2" className="info-value">{details?.awb_no}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box className="header-actions">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<Print />}
                                    className="action-button"
                                >
                                    Print Label
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<Receipt />}
                                    className="action-button"
                                >
                                    Print Invoice
                                </Button>
                                {/* <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<ContentCopy />}
                                    className="action-button"
                                >
                                    Clone
                                </Button> */}
                                <IconButton onClick={handleToggleDrawer} className="close-button">
                                    <Close />
                                </IconButton>
                            </Box>
                        </Box>

                        <Divider />

                        {/* Content */}
                        <Box className="drawer-body" id="drawer-body-content">
                            <Grid container spacing={2}>
                                {/* Order Section */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <Card className="info-card">
                                        <CardContent>
                                            <Typography variant="h6" className="card-title">
                                                <ShoppingBag className="title-icon" />
                                                Order
                                            </Typography>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Order No:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.order_no}</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Date:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.created_at ? moment(details?.created_at).format('DD-MM-YYYY') : ''}</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Payment Type:</Typography>
                                                <Typography variant="body2" className="info-value">{delivery_type_id[details?.delivery_type_id]}</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Booking Type:</Typography>
                                                <Typography variant="body2" className="info-value">{booking_type_id[details?.booking_type_id]}</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Order Status:</Typography>
                                                <Chip
                                                    label={getOrderStatus(details?.order_status_id)}
                                                    size="small"
                                                    className="status-chip"
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {/* Weight Details */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <Card className="info-card">
                                        <CardContent>
                                            <Typography variant="h6" className="card-title">
                                                <Scale className="title-icon" />
                                                Weight Details
                                            </Typography>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Weight:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.product_weight_in_kgs} kg[s]</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Dimension:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.height_in_cms} * {details?.breadth_in_cms} * {details?.height_in_cms}</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Volumetric Weight:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.product_vol_weight_in_kgs} kg[s]</Typography>
                                            </Box>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Charged Weight Slab:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.chargeable_weight_in_kgs} kg[s]</Typography>
                                            </Box>

                                            {/* <Box className="courier-info">
                                                <Box className="info-item">
                                                    <Typography variant="body2" className="info-label">Courier:</Typography>
                                                    <Typography variant="body2" className="info-value">{details?.courier?.brand_name}</Typography>
                                                </Box>
                                                <Box className="info-item">
                                                    <Typography variant="body2" className="info-label">AWB:</Typography>
                                                    <Typography variant="body2" className="info-value link-text">{details?.awb_no}</Typography>
                                                </Box>
                                                <Box className="info-item">
                                                    <Typography variant="body2" className="info-label">Essential:</Typography>
                                                    <Typography variant="body2" className="info-value">{details?.essential}</Typography>
                                                </Box>
                                            </Box> */}
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Warehouse Details */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <Card className="info-card">
                                        <CardContent>
                                            <Typography variant="h6" className="card-title">
                                                <Inventory className="title-icon" />
                                                Warehouse Details
                                            </Typography>
                                            <Typography variant="body1" className="warehouse-name">
                                                {details?.merchant_warehouse?.contact_person}
                                            </Typography>
                                            <Typography variant="body2" className="address-text">
                                                {details?.merchant_warehouse?.address_1} {details?.merchant_warehouse?.address_2}
                                            </Typography>
                                            <Typography variant="body2" className="address-text">
                                                {details?.merchant_warehouse?.city}
                                            </Typography>
                                            <Typography variant="body2" className="address-text">
                                                {details?.merchant_warehouse?.state}
                                            </Typography>
                                            <Typography variant="body2" className="address-text">
                                                {details?.merchant_warehouse?.pincode}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Shipping & Billing Details */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <Card className="info-card">
                                        <CardContent>
                                            <Typography variant="h6" className="card-title">
                                                <LocalShipping className="title-icon" />
                                                Shipping & Billing Details
                                            </Typography>
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Customer Name:</Typography>
                                                <Typography variant="body1" className="customer-name">
                                                    {details?.customer_name}
                                                </Typography>
                                            </Box>
                                            {/* <Typography variant="body1" className="project-name">
                                                {details?.project_name}
                                            </Typography> */}
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Project Name:</Typography>
                                                <Typography variant="body2" className="info-value">{details?.project_name}</Typography>
                                            </Box>
                                            <Typography variant="body2" className="address-text">
                                                {details?.customer_address}
                                            </Typography>
                                            {/* <Typography variant="body2" className="address-text">
                                                {details?.shipping?.landmark}
                                            </Typography> */}
                                            <Box className="info-item">
                                                <Typography variant="body2" className="info-label">Addreess:</Typography>
                                                <Typography variant="body2" className="address-text">
                                                    {details?.customer_city}, {details?.customer_state} {details?.customer_pincode}
                                                </Typography>
                                                {/* <Typography variant="body2" className="address-text">
                                                {details?.shipping?.country}
                                            </Typography> */}
                                                <Typography variant="body2" className="phone-text">
                                                    {details?.customer_mobile}
                                                </Typography>
                                                <Typography variant="body2" className="email-text">
                                                    {details?.customer_email}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>


                                {/* Product Table */}
                                <Grid item size={{ xs: 12, md: 12 }}>
                                    <Card className="product-table-card info-card">
                                        <Typography variant="h6" className="card-title">
                                            <InventoryRounded className="title-icon" />
                                            Product Information
                                        </Typography>
                                        <CardContent>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="table-header">PRODUCT</TableCell>
                                                        <TableCell className="table-header">PRODUCT SKU</TableCell>
                                                        <TableCell className="table-header">QUANTITY</TableCell>
                                                        <TableCell className="table-header">ITEM PRICE</TableCell>
                                                        <TableCell className="table-header">PRODUCT TOTAL</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>{details?.product_name || 'NA'}</TableCell>
                                                        <TableCell>{details?.product?.sku || 'NA'}</TableCell>
                                                        <TableCell>{details?.product_qty || 'NA'}</TableCell>
                                                        <TableCell>{details?.product?.price || 'NA'}</TableCell>
                                                        <TableCell>{details?.product?.total || 'NA'}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>

                                            <Box className="order-summary">
                                                {/* <Box className="summary-row">
                                                    <Typography className="summary-label">COD Charges</Typography>
                                                    <Typography className="summary-value">{details?.product_cod_value} Rs.</Typography>
                                                </Box> */}
                                                <Box className="summary-row total-row">
                                                    <Typography className="summary-label">Grand Total</Typography>
                                                    <Typography className="summary-value">{details?.product_invoice_value} Rs.</Typography>
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 12 }}>
                                    <Card className="info-card">
                                        <CardContent>
                                            <Typography variant="h6" className="card-subtitle">
                                                {/* <CircleNotificationsRounded className="title-icon" /> */}
                                                Add Remarks
                                            </Typography>
                                            <form onSubmit={handleRemarksSubmit}>
                                                <Paper className={'paper'}>
                                                    <div className={'column-form'}>
                                                        <TextField
                                                            className='custom-input'
                                                            label={"Enter Remarks"}
                                                            value={formRemaks.remarks}
                                                            name="remarks"
                                                            onChange={(e) => { handleChange(e) }}
                                                            fullWidth
                                                            multiline
                                                            rows={4}
                                                            error={!!formErrors?.remarks}
                                                            helperText={formErrors?.remarks}
                                                        />
                                                    </div>
                                                </Paper>
                                                <Box sx={{ width: '100%', textAlign: 'right', marginTop: '2rem' }}>
                                                    <Button variant="contained" color="primary" type="submit">
                                                        Submit
                                                    </Button>
                                                </Box>
                                            </form>

                                            <Typography variant="h6" className="card-title">
                                                <CircleNotificationsRounded className="title-icon" />
                                                Remarks History
                                            </Typography>
                                            <TableContainer component={Paper} sx={{ mt: 3 }}>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>User ID </TableCell>
                                                            <TableCell>User Name</TableCell>
                                                            <TableCell>Remarks</TableCell>
                                                            <TableCell>Created At</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {allRemarks && allRemarks.length > 0 ? allRemarks.map((row, index) => {
                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell>
                                                                        {row?.user_id || "N/A"}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {row?.user?.name || "N/A"}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {row?.remarks || "N/A"}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <Typography variant="body2" fontWeight="bold">
                                                                            {row.created_at ? moment(row.created_at).format("DD-MM-YYYY") : "N/A"}
                                                                        </Typography>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        }) : <TableRow>
                                                            <TableCell colSpan={4} align="center">
                                                                No Remarks Found
                                                            </TableCell>
                                                        </TableRow>}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            {/* <Grid container spacing={3}>
                                <Grid item xs={12} sm={12}>
                                    <Paper elevation={3} sx={{ marginBottom: '1rem', height: '100%', textAlign: 'left', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                                        <Typography>AWB Number: <strong>{details?.awb_no ? details?.awb_no : 'NA'}</strong></Typography>
                                        <Typography>Courier: <strong>{details?.courier?.brand_name ? details?.courier?.brand_name : 'NA'}</strong></Typography>
                                        <Typography>Status:  <strong>{details?.order_status_id ? getOrderStatus(details?.order_status_id) : 'NA'}</strong></Typography>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper elevation={3} sx={{ marginBottom: '1rem', height: '100%', textAlign: 'left', padding: '0.5rem 1rem' }}>
                                        <CardHeader title='Customer Details' />
                                        <Table size="small">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Name:</TableCell>
                                                    <TableCell>{details?.customer_name}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Phone:</TableCell>
                                                    <TableCell>{details?.customer_mobile}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Email:</TableCell>
                                                    <TableCell>{details?.customer_email ?? 'NA'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Pincode:</TableCell>
                                                    <TableCell>{details?.customer_pincode}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>City:</TableCell>
                                                    <TableCell>{details?.customer_city}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>State:</TableCell>
                                                    <TableCell>{details?.customer_state}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Address:</TableCell>
                                                    <TableCell>{details?.customer_address}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper elevation={3} sx={{ marginBottom: '1rem', height: '100%', textAlign: 'left', padding: '0.5rem 1rem' }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }} className=''>
                                            <CardHeader title='Product Details' />
                                            </Box>
                                        <Table size="small">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell>{details?.product_name}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Length (cm)</TableCell>
                                                    <TableCell>{details?.length_in_cms} cm[s]</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Breadth (cm)</TableCell>
                                                    <TableCell>{details?.breadth_in_cms} cm[s]</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Height (cm)</TableCell>
                                                    <TableCell>{details?.height_in_cms} cm[s]</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Quantity</TableCell>
                                                    <TableCell>{details?.product_qty}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Weight (kg)</TableCell>
                                                    <TableCell>{details?.product_weight_in_kgs} kg[s]</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>COD Value</TableCell>
                                                    <TableCell>{details?.product_cod_value}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Invoice Value</TableCell>
                                                    <TableCell>{details?.product_invoice_value}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Code</TableCell>
                                                    <TableCell>{details?.product_code}</TableCell>
                                                </TableRow>
                                                </TableBody>
                                        </Table>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper elevation={3} sx={{ marginBottom: '1rem', height: '100%', textAlign: 'left', padding: '0.5rem 1rem' }}>
                                        <CardHeader title='Pickup Details' />
                                        <Table size="small">
                                            <TableBody>
                                                {user?.user_type !== "Merchant" && merchant?.length ?
                                                    <TableRow>
                                                        <TableCell>
                                                            {user?.user_type !== "Merchant" &&
                                                                <Select
                                                                    value={formData?.new_merchant_id ?? ''}
                                                                    onChange={handleInputChange}
                                                                    name='new_merchant_id'
                                                                    displayEmpty
                                                                    sx={{ width: '100%', textAlign: 'left', maxWidth: '200px', minWidth: '150px' }}
                                                                    inputProps={{ 'aria-label': 'Select Merchant' }}
                                                                    className='select-input'
                                                                    fullWidth
                                                                >
                                                                    <MenuItem value="" disabled>
                                                                        Select Merchant
                                                                    </MenuItem>
                                                                    {merchant.map((item) => (
                                                                        <MenuItem key={item.id} value={item.id}>
                                                                            {item.company_name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button
                                                                className='table-common-button'
                                                                variant='outlined'
                                                                color='primary'
                                                                onClick={() => onMerchantUpdate()}
                                                                sx={{ marginRight: '0.5rem' }}
                                                            >Update Merchant</Button>
                                                        </TableCell>
                                                    </TableRow>
                                                    :
                                                    ''
                                                }
                                                <TableRow>
                                                    <TableCell>AWB Number:</TableCell>
                                                    <TableCell>{details?.awb_no}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Pickup Pincode:</TableCell>
                                                    <TableCell>{details?.pickup_pincode}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Warehouse:</TableCell>
                                                    <TableCell>{details?.merchant_warehouse?.contact_person}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Mobile:</TableCell>
                                                    <TableCell>{details?.merchant_warehouse?.mobile}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Pincode:</TableCell>
                                                    <TableCell>{details?.merchant_warehouse?.pincode}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Service:</TableCell>
                                                    <TableCell>{service[details?.service_id]}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Zone:</TableCell>
                                                    <TableCell>{zones[details?.zone_category_id]}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Total Attempt:</TableCell>
                                                    <TableCell>{details?.total_attempt}</TableCell>
                                                </TableRow>
                                               </TableBody>
                                        </Table>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper elevation={3} sx={{ marginBottom: '1rem', height: '100%', textAlign: 'left', padding: '0.5rem 1rem' }}>
                                        <CardHeader title='Order Details' />
                                        <Table size="small">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Order Number</TableCell>
                                                    <TableCell>{details?.order_no}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Reference Number</TableCell>
                                                    <TableCell>{details?.system_order_no}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Booking Type</TableCell>
                                                    <TableCell>{booking_type_id[details?.booking_type_id]}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Service provider</TableCell>
                                                    <TableCell>{details?.service_provider_name ?? 'NA'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Status</TableCell>
                                                    <TableCell>
                                                        {getOrderStatus(details?.order_status_id)}

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Created At</TableCell>
                                                    <TableCell>{details?.created_at ? moment(details?.created_at).format('DD-MM-YYYY') : 'NA'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Updated At</TableCell>
                                                    <TableCell>{details?.updated_at ? moment(details?.updated_at).format('DD-MM-YYYY') : 'NA'}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Paper elevation={3} sx={{ marginBottom: '1rem', height: '100%', textAlign: 'left', padding: '0.5rem 1rem' }}>
                                       <CardHeader title='Remarks' />
                                        <form onSubmit={handleRemarksSubmit}>
                                            <Paper className={'paper'}>
                                                <div className={'column-form'}>
                                                    <TextField
                                                        className='custom-input'
                                                        label={"Enter Remarks"}
                                                        value={formRemaks.remarks}
                                                        name="remarks"
                                                        onChange={(e) => { handleChange(e) }}
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        error={!!formErrors?.remarks}
                                                        helperText={formErrors?.remarks}
                                                    />
                                                </div>
                                            </Paper>
                                            <Box sx={{ width: '100%', textAlign: 'right', marginTop: '2rem' }}>
                                                <Button variant="contained" color="primary" type="submit">
                                                    Submit
                                                </Button>
                                            </Box>
                                        </form>
                                        <TableContainer component={Paper} sx={{ mt: 3 }}>
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>User ID </TableCell>
                                                        <TableCell>User Name</TableCell>
                                                        <TableCell>Remarks</TableCell>
                                                        <TableCell>Created At</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {allRemarks && allRemarks.length > 0 ? allRemarks.map((row, index) => {
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    {row?.user_id || "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {row?.user?.name || "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {row?.remarks || "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography variant="body2" fontWeight="bold">
                                                                        {row.created_at ? moment(row.created_at).format("DD-MM-YYYY") : "N/A"}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    }) : <TableRow>
                                                        <TableCell colSpan={4} align="center">
                                                            No Remarks Found
                                                        </TableCell>
                                                    </TableRow>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Grid>
                            </Grid> */}
                        </Box>
                    </Box>
                </Drawer>
            </Box>
        </ThemeProvider>
    );
};

export default OrderDetails;